import styled, { Interpolation } from '@emotion/styled';
import DefaultButton from './DefaultButton';
import { ReactNode } from 'react';
import { Theme } from '@emotion/react';
import { Variant } from './makeBtnSize';

const PrimaryButtonStyled = styled(DefaultButton)`
	color: white;
	background-color: ${({ theme }) => theme.colors.brand.main};
	border: none;
	justify-content: center;

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => theme.colors.brand.dark};
	}
`;

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	icon?: ReactNode;
	children?: ReactNode;
	xStyle?: Interpolation<Theme>;
	variant?: Variant;
	disabled?: boolean;
};

export const PrimaryButton = ({ icon, children, variant = 'large', xStyle = {}, disabled = false, ...props }: Props) => {
	return (
		<PrimaryButtonStyled variant={variant} css={xStyle} disabled={disabled} {...props}>
			{icon ? <span className="icon">{icon}</span> : null}
			{children}
		</PrimaryButtonStyled>
	);
};
